<template>
  <div class="mt-0">
    <div v-if="loading" class="p-5 text-center">
      <FacebookLoader :color="colors.primary" />
      <div v-if="isBigPoll" class="loading-mesage">
        Still loading ...
      </div>
    </div>
    <poll-renderer v-if="!loading" />
    <div v-if="0">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/shared/http';
import shared from '@/shared.js';
import Renderer from '@/components/Rendering/Renderer.vue';
// import { deviceMixin } from '@/components/mixins/DeviceMixins';

import { FacebookLoader } from 'vue-spinners-css';
import colors from '@/styles/colors.scss';
import { mapState, mapGetters, mapActions } from 'vuex';
//import { constants } from '@/shared/constant';

export default {
  name: 'Poll',
  mixins: [
    // deviceMixin,
  ],
  data() {
    return {
      colors: colors,
      loading: true,
      error: null,
      isBigPoll: false,
    };
  },

  components: {
    'poll-renderer': Renderer,
    FacebookLoader,
  },

  methods: {
    ...mapActions(['updateCurrentDisplayUser', 'updatePollStatus']),
    updateChoices() {
      // let atLeastOneText = false;
      // for (let choice of this.poll.choices) {
      //   if (choice.text) {
      //     atLeastOneText = true;
      //     break;
      //   }
      // }
      // if (!atLeastOneText) return;
      for (let choice of this.poll.choices) {
        if (!choice.text) {
          choice.text = '-';
        }
      }
      this.poll.choices.sort(function (a, b) {
        return new Date(a.start) - new Date(b.start);
      });
    },

    updateInfoLine(key) {
      if (!this.isAuthenticated) {
        console.log('Update the info line for not authenticated users');
        this.$store.commit(
          'setInfo',
          'Learn about the advantages of using Kulibri as a logged in user!'
        );
      } else {
        if (key) {
          console.log('Invitation key:', key);
          let index = this.poll.invitations.map((e) => e.id).indexOf(key);
          if (index >= 0) {
            let email = this.poll.invitations[index].email;
            let msg =
              'Please save the link. It is the private invitation for:' + email;
            console.log(msg);
            this.$store.commit('setInfo', msg);
          }
        } else {
          console.log(
            'Update the info line for authenticated users and key not found.'
          );
          this.$store.commit('setInfo', null);
        }
      }
    },

    isAdminKey(key) {
      let response = { isAdmin: false, isSubAdmin: null, value: false };
      //console.error("Check for admin  key:", key, this.poll.key);
      if (key && this.poll) {
        // --- subadmin ---
        if (key == this.poll.key) {
          response.isAdmin = true;
          response.value = true;
          // update current display user when we find any participant/admin from the list
          this.updateCurrentDisplayUser(this.poll.user);
          return response;
        } else {
          response.isSubAdmin = this.poll.participants.find(
            (participant) => participant.invitation_id == key
          );
          if (response.isSubAdmin) {
            response.value = response.isSubAdmin.is_sub_admin == 1;
            // update current display user when we find any participant from the list
            this.updateCurrentDisplayUser(response.isSubAdmin.user);
          }
          if (response.value == true) {
            this.$store.commit('setSubAdminDetails', {
              value: response.value,
              id: response.isSubAdmin.user_id,
            });
          }
          return response;
        }
        // --- subadmin end ---
      }
      // if( key && this.poll.key && key == this.poll.key ) return true;
      let start = key.substring(0, 4);
      let end = key.substring(key.length - 4);
      console.log('Admin Key: Start and End of the key', start, end);
      response.value = start === end;
      return response;
    },

    isLegacyAdminKey(key) {
      //console.error("Check for admin  key:", key, this.poll.key);
      let start = key.substring(0, 4);
      let end = key.substring(key.length - 4);
      console.log('Admin Key: Start and End of the key', start, end);
      return start === end;
    },

    isPublicKey(key) {
      let start = key.substring(0, 4);
      let end = key.substring(4, 8);
      console.log('Public Key: Start and End of the key', start, end);
      return start === end;
    },

    updateInvitation(key) {
      console.error("updateInvitation:", key);
      let isUserWithAdminOrSubAdminRole = this.isAdminKey(key);


      if (isUserWithAdminOrSubAdminRole.value == true) {
        let keyUserId = this.poll.user.id;
        if (isUserWithAdminOrSubAdminRole.isSubAdmin != null) {
          keyUserId = isUserWithAdminOrSubAdminRole.isSubAdmin.user_id;
          if (isUserWithAdminOrSubAdminRole.isSubAdmin.user) {
            this.$i18n.locale =
              isUserWithAdminOrSubAdminRole.isSubAdmin.user.locale;
          }
        } else {
          // update also the locale for the admin user
          if (this.poll.user) {
            this.$i18n.locale = this.poll.user.locale;
          }
        }

        if (
          this.user &&
          isUserWithAdminOrSubAdminRole.isSubAdmin &&
          isUserWithAdminOrSubAdminRole.isSubAdmin.user &&
          this.user.email != isUserWithAdminOrSubAdminRole.isSubAdmin.user.email
        ) {
          console.log(
            'Logout current user:',
            this.user.email,
            isUserWithAdminOrSubAdminRole.isSubAdmin.user.email
          );

          // unauthenticated user in frontend to avoid async conflicts
          this.updateUnAuthenticatedUserWhenRequest();
          this.$store.commit('setIsAdminLink', true);
          this.$store.commit('setIsPublicLink', false);
          this.$store.commit('setKeyUserId', keyUserId);
          this.$store.dispatch('logout', false);
        } else {
          this.$store.commit('setIsAdminLink', true);
          this.$store.commit('setIsPublicLink', false);
          this.$store.commit('setKeyUserId', keyUserId);
        }

        return;
      }

      if (this.isPublicKey(key)) {
        console.error("ispPublicLink");
        this.$store.commit('setIsAdminLink', false);
        this.$store.commit('setIsPublicLink', true);
        this.$store.commit('setInvitation', null);
        return;
      }

      this.$store.commit('setIsAdminLink', false);
      this.$store.commit('setIsPublicLink', false);

      const invitation = this.poll.invitations.find(
        (element) => element.id == key
      );
      console.error('Invitation found:', invitation);
      if (!invitation) {
        console.log('This invitation was  deleted');
        let url = '/deleted';
        console.log('loadData redirect to url:', url);
        this.$router.push(url);
        return;
      }

      // check if the current user is different than the invited
      if (this.user && this.user.email != invitation.email) {
        console.log('Logout current user:', this.user.email, invitation.email);

        // unauthenticated user in fronend to avoid async cinflicts
        this.updateUnAuthenticatedUserWhenRequest();
        this.$store.dispatch('logout', false);
      }

      if (invitation && !invitation.visited) {
        invitation.visited = true;
        this.$store.dispatch('invitationVisit', invitation);
      }

      this.$store.commit('setInvitationId', key);
      this.$store.commit('setInvitation', invitation);
    },
    updateUnAuthenticatedUserWhenRequest() {
      this.$store.commit('SET_AUTHENTICATED', false);
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_SESSION_COOKIE', null);
      this.$store.commit('SET_USER_ID', null);
    },
    showEmailsOfInvitedParticipants() {
      let participants = this.poll.participants;
      var length = participants.length;
      for (var i = 0; i < length; i++) {
        let participant = participants[i];

        if (participant.invited) {
          let id = participant.id;
          let invIndex = this.poll.invitations.findIndex(
            (x) => x.participant_id === id
          );
          if (invIndex > -1) {
            participant.email = this.poll.invitations[invIndex].email;
          } else {
            participant.email = null;
          }
        } else participant.email = null;
      }
      // this is
      // this.$nextTick(function () {
      //   $('[data-toggle="tooltip"]').tooltip();
      // });
    },
    retrieveUser() {
      console.log('Retrieve user from local storage');
    },

    loadData(pollId, redirectToAdmin = false, pollKey = null) {
      const startTime = new Date();
      //console.error('loadData redirectToAdmin:', redirectToAdmin, pollKey);
      const key = pollKey ? pollKey : this.$route.params.key;

      // key is second part of the link and is
      let adminKey = null;

      if (key && !this.isPublicKey(key) && !this.isLegacyAdminKey(key)) {
        adminKey = key;
      }
      const poll = {
        pollId,
        key: adminKey,
      };
      //console.log('loadData redirectToAdmin:', redirectToAdmin, poll);
      this.$store
        .dispatch('loadPoll', poll)
        .then((res) => {
          const loadTime = new Date();
          const timeDiff = (loadTime - startTime) / 1000; //in s
          console.info('loadData completed in :', timeDiff);
          this.error = res;
          this.loading = false;

          if (redirectToAdmin) {
            poll.key = key;
          }
          //console.error('Project key :', poll.key);
          if (this.poll.type == 0) {
            console.log('This project is deleted');
            let url = '/deleted';
            console.log('loadData redirect to url:', url);
            this.$router.push(url);
            return;
          }

          if (key) {
            this.updateInvitation(key);
          } else {
            this.$store.commit('setInvitation', null);
            this.$store.commit('setIsPublicLink', false);
            console.log('No invitation key found');
          }
          // this will set the empty array for the delay interval
          this.$store.commit('updateDelayInterval', []);
          this.error = '<br>Check for admin completed';
          this.loading = false;
          let choices = res.data.choices;
          if (choices) {
            let choicesCount = choices.length;
            this.newParticipantPreferences = Array(choicesCount);
            const info = choicesCount + ' choices found';
            console.log(info);
            this.error = '<br>' + info;
          } else {
            console.log('Choices not available for the poll');
            this.error = '<br>Choices not available for the poll';
          }

          this.updateChoices();
          this.error += '<br>Choices where updated';
          this.updateInfoLine(key);
          this.error += '<br>Info line updated';

          if (this.isOwner) {
            this.showEmailsOfInvitedParticipants();
          }
          // this.retrieveUser();
          this.error += '<br>User retrieved';
          this.loading = false;
          if (redirectToAdmin) {
            let url = '/pr/' + pollId + '/' + this.poll.key;
            console.error('loadData redirect to url:', url);
            this.$router.push(url);
          }
          const finalTime = new Date();
          const time2Diff = (finalTime - startTime) / 1000; //in s
          console.info('FinalLoad completed in :', time2Diff, Date.now());
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
          console.log('load poll error: ', error);
        });
    },

    createNewPoll() {
      let data = {};
      console.time('(CreateNewPosll)');
      data.title = this.$t('polls.defaultPollTitle');
      data.description = '';
      data.options = {
        initialised: false,
        privacy: 'closed',
        reminder: '3',
        poll_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // setDefaultAsNoForNotAnswered: true
      };
      data.type = 1;
      data.bg_image_path = this.bgDefaultImage.url;
      data.choices = null;

      if (this.isAuthenticated) {
        console.log('create new Poll - Authenticated userId:', this.userId);
        data.isRegisteredUser = true;
        data.ownerUser = null;
        data.user_id = this.userId;
        data.locale = this.$i18n.locale;
      } else {
        console.log('create new Poll - anonymous user userId:', this.userId);
        data.isRegisteredUser = false;
        data.ownerUser = this.ownerUser;
        data.user_id = null;
        data.locale = this.$i18n.locale;
      }
      console.log('createNewPoll:data', data);
      // console.log('Create new project with choices:', data.choices);
      HTTP.post('/api/new', data)
        .then((response) => {
          console.error('Create new:', response.data);
          let pollId = response.data.poll_id;
          const key = response.data.admin_id;
          const locale = response.data.locale;
          let redirectToAdmin = true;
          this.$store.commit('setIsAdminLink', true);
          this.$store.commit('setIsPublicLink', false);
          this.loadData(pollId, redirectToAdmin, key);
          this.$i18n.locale = locale;
          console.timeEnd('(CreateNewPosll)');
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  computed: {
    ...mapState({
      userId: (state) => state.Login.userId,
      keyUserId: (state) => state.keyUserId,
      user: (state) => state.Login.user,
      poll: (state) => state.poll.poll,
    }),

    ...mapGetters(['isOwner', 'adminKey', 'isAuthenticated', 'bgDefaultImage']),

    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },

  mounted() {
    console.info('(Poll) mounting started');
    setTimeout(() => {
      this.isBigPoll = true;
    }, 5000);

    this.$store.commit('setVisibleNav', false);
    this.lastUpdate = shared.lastUpdate; // now you can call this.foo() (in your functions/template)

    let id = this.$route.params.id;

    console.log('Load new poll:', id);

    if (id == 'newde') {
      id = 'new';
      this.$i18n.locale = 'de';
    }

    if (id == 'newen') {
      id = 'new';
      this.$i18n.locale = 'en';
    }

    this.$store.dispatch('initCsrf').then(() => {
      this.$store.commit('setIsAdminLink', false);
      if (id == 'new') {
        this.updatePollStatus(true);
        this.createNewPoll();
      } else {
        this.updatePollStatus(false);
        this.loadData(id);
      }
      console.info('(Poll) mounting end');
    });
    console.info('(Poll) mounting completed');
  },
};
</script>
